@if (visible() && config(); as c) {
    <div
        class="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fade-in"
        role="presentation"
    >
        <!-- Backdrop: click-to-cancel. Keyboard closes via Escape (focus trap). -->
        <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events,@angular-eslint/template/interactive-supports-focus -->
        <div
            class="absolute inset-0 bg-surface-900/50 backdrop-blur-[2px]"
            (click)="confirm(false)"
            aria-hidden="true"
        ></div>

        <div
            #dialog
            class="relative bg-white rounded-2xl shadow-soft-lg max-w-sm w-full p-5 animate-scale-in"
            role="alertdialog"
            aria-modal="true"
            aria-labelledby="confirm-title"
            aria-describedby="confirm-message"
        >
            @if (c.icon) {
                <div class="flex justify-center mb-3">
                    <div
                        class="size-12 rounded-xl flex items-center justify-center"
                        [ngClass]="{
                            'bg-primary-50 text-primary-600':
                                c.icon === 'update' || c.icon === 'info',
                            'bg-accent-50 text-accent-700':
                                c.icon === 'warning',
                            'bg-danger-50 text-danger-600': c.icon === 'delete',
                        }"
                        aria-hidden="true"
                    >
                        @if (c.icon === 'update') {
                            <i
                                class="fa-solid fa-arrow-rotate-right text-xl"
                            ></i>
                        }
                        @if (c.icon === 'warning') {
                            <i
                                class="fa-solid fa-triangle-exclamation text-xl"
                            ></i>
                        }
                        @if (c.icon === 'info') {
                            <i class="fa-solid fa-circle-info text-xl"></i>
                        }
                        @if (c.icon === 'delete') {
                            <i class="fa-solid fa-trash text-xl"></i>
                        }
                    </div>
                </div>
            }

            <h3
                id="confirm-title"
                class="text-lg font-semibold text-surface-900 text-center font-display mb-1.5"
            >
                {{ c.title }}
            </h3>

            <p
                id="confirm-message"
                class="text-surface-600 text-sm text-center mb-5 leading-relaxed"
            >
                {{ c.message }}
            </p>

            <div class="flex gap-2">
                <button
                    type="button"
                    (click)="confirm(false)"
                    class="btn-secondary flex-1"
                >
                    {{ c.cancelText }}
                </button>
                <button
                    type="button"
                    (click)="confirm(true)"
                    class="flex-1"
                    [ngClass]="
                        c.icon === 'delete' ? 'btn-danger' : 'btn-primary'
                    "
                >
                    {{ c.confirmText }}
                </button>
            </div>
        </div>
    </div>
}
